<template>
  <div class="lylb-container">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="tcf-notedit" v-if="!ishavecard">
          <div class="tcf-notedit-spinner">
            未设置数字名片，<router-link to="/work/mpsz" class="a-txt">点击这里立即去设置</router-link>
          </div>
        </div>
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="处理状态">
              <el-select v-model="searchForm.mark" style="width: 120px" clearable>
                <el-option label="未处理" :value="0" />
                <el-option label="已处理" :value="1" />
              </el-select>
            </el-form-item>
            <el-form-item label="搜索关键字">
              <el-input v-model="searchForm.search" placeholder="请输入关键字" @keyup.enter.native="Search"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search">搜索</el-button>
            </el-form-item>
          </el-form>
          <div class="card-content" v-loading="loading">
            <el-table
              :data="tableData"
              stripe
              style="width: 100%;margin-bottom: 20px">
              <el-table-column
                label="#"
                width="40">
                <template slot-scope="scope">
                  <el-avatar :size="30" :src="scope.row.photourl"></el-avatar>
                </template>
              </el-table-column>
              <el-table-column
                prop="nickname"
                label="微信用户"
                width="100"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                prop="name"
                label="姓名"
                width="90"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                prop="tel"
                label="电话"
                width="120"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                prop="province"
                label="所在地区"
                width="160"
                show-overflow-tooltip>
                <template slot-scope="scope">
                  {{scope.row.province}} {{scope.row.city}} {{scope.row.county}}
                </template>
              </el-table-column>
              <el-table-column
                prop="time"
                label="留言时间"
                width="150"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                prop="content"
                label="留言内容"
                min-width="200"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                label="处理状态"
                width="100"
                fixed="right"
                show-overflow-tooltip>
                <template slot-scope="scope" >
                  <el-tag v-if="scope.row.mark==0" :disable-transitions="true" size="mini" type="danger">未处理</el-tag>
                  <el-tag v-if="scope.row.mark==1" :disable-transitions="true" size="mini">已处理</el-tag>
                </template>
              </el-table-column>
              <el-table-column
                label="操作"
                width="100"
                align="center"
                fixed="right"
                show-overflow-tooltip>
                <template slot-scope="scope">
                  <el-button icon="el-icon-document-checked" :disabled="scope.row.mark==1" size="mini" @click="oper(scope.row)">处理</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <el-pagination
            v-if="total>0"
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[20, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { selectLeaveWordList, selectUseridCallingCard, operLeaveWord } from '@/api/zsxcx'
import { forwardClient } from '@/api/work'
export default {
  name: 'lylb',
  computed: {
    user: getUser
  },
  data() {
    return {
      ishavecard: false,
      loading: false,
      tableData: [],
      total: 0,
      currentPage: 1,
      pageSize: 20,
      searchForm: {
        search: '',
        mark: null
      }
    }
  },
  created() {
    this.getCardInfo()
  },
  methods: {
    getCardInfo() {
      selectUseridCallingCard({ userid: this.user.dUserid }).then(response => {
        if (response.data !== null && response.data !== undefined) {
          this.ishavecard = true
          this.getData()
        }
      })
    },
    oper(row) {
      this.$confirm('确认处理此条留言吗?', '处理留言', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        operLeaveWord({ wordid: row.wordid }).then(response => {
          this.$message({
            message: response.msg,
            type: 'success'
          })
          this.getData()
        }).catch(() => {})
      }).catch(() => {})
    },
    Search() {
      this.getData()
    },
    getData() {
      const data = {
        userid: this.user.dUserid,
        page: this.currentPage,
        limit: this.pageSize,
        content: this.searchForm.search,
        mark: this.searchForm.mark
      }
      selectLeaveWordList(data).then(response => {
        this.tableData = response.data
        this.total = response.total
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    }
  }
}
</script>

<style scoped>

</style>
